enum ScoreIntentClassStyleType {
  warning = 'warning',
  success = 'success',
  danger = 'danger',
  default = 'default',
  eq1 = 'eq1',
  eq2 = 'eq2',
  eq3 = 'eq3',
  eq4 = 'eq4',
  eq5 = 'eq5',
}

export const getComparedToAverageClassStyle = (delta?: number): 'success' | 'warning' | 'danger' | 'default' => {
  if (delta === undefined) {
      return ScoreIntentClassStyleType.default;
  }
  if (delta > 2) {
      return ScoreIntentClassStyleType.success;
  }
  if (delta < -2) {
      return ScoreIntentClassStyleType.danger;
  }
  return ScoreIntentClassStyleType.warning;
};

export const getComparedToClassStyle = (delta?: number): 'success' | 'warning' | 'danger' | 'default' => {
  if (delta === undefined) {
      return ScoreIntentClassStyleType.default;
  }
  if (delta >= 0) {
      return ScoreIntentClassStyleType.success;
  } else {
      return ScoreIntentClassStyleType.danger;
  }
};
